import { Extension } from '@tiptap/core'
import { createExportScopePlugin } from './export-scope-plugin'

export const ExportScopeExtension = Extension.create({
  name: 'exportScope',

  addProseMirrorPlugins() {
    return [createExportScopePlugin()]
  },
})
